import * as React from "react";

export const Centered: React.FC = (props) => <div className={`spaces-centered`}>{props.children}</div>;
